// Dias que le quedan a la prueba, redondeando hacia arriba: con 2,5 dias por
// delante la persona espera leer "quedan 3", no "quedan 2".
export function diasRestantes(expiresAt, ahora = Date.now()) {
    const ms = new Date(expiresAt).getTime() - ahora;
    return Number.isFinite(ms) ? Math.max(0, Math.ceil(ms / 86400000)) : 0;
}
